import { useFlags, useLDClient } from 'launchdarkly-react-client-sdk';
import { useEffect, useState } from 'react';

import { flagsContext } from '@/contexts/flagsContext';
import { parseJson } from '@/utils/string';

import { useEnvironment } from './useEnvironment';

export const useFeatureFlags = () => {
  const conductedFlags = useFlags(flagsContext);
  const flagsOverrides =
    typeof window === 'undefined'
      ? null
      : new URLSearchParams(window.location.search).get('flags');

  if (!flagsOverrides) {
    return conductedFlags;
  }

  const flags = flagsOverrides.split(',').reduce((acc, flag) => {
    const parts = flag.split(':');
    const [key, value] = parts;
    if (parts.length === 1) {
      return { ...acc, [key]: true };
    }

    const parsedValue = parseJson(value);
    return { ...acc, [key]: parsedValue === undefined ? value : parsedValue };
  }, {});

  return {
    ...conductedFlags,
    ...flags,
  };
};

export const useLaunchDarkly = () => {
  const { isDemo, isDev, isTest } = useEnvironment();
  const [ldClientReady, setLDClientReady] = useState(isDemo || isDev || isTest);
  const ldClient = useLDClient(flagsContext);

  useEffect(() => {
    void ldClient?.waitUntilReady().then(() => setLDClientReady(true));
  }, [ldClient]);

  return { isReady: ldClientReady };
};
